import { defineMessages } from 'react-intl';

export const bypassProductListPageLayoutMessages = defineMessages({
  filter: {
    id: 'productListPageLayout.filter.bypass.headline',
    defaultMessage: 'Filter überspringen',
  },
  products: {
    id: 'productListPageLayout.products.bypass.headline',
    defaultMessage: 'Produkte überspringen',
  },
  categoryNavigation: {
    id: 'productListPageLayout.categoryNavigation.bypass.headline',
    defaultMessage: 'Kategorie-Navigation überspringen',
  },
});
